import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-reservation-card-userdata',
  templateUrl: './reservation-card-userdata.component.html',
  styleUrls: ['./reservation-card-userdata.component.scss']
})
export class ReservationCardUserdataComponent implements OnInit {
  @Input() reservation: any;
  constructor() {}
  ngOnInit(): void {

  }
}
